<template>
  <div style="height:100%">
    <portal to="app-header">
      <span>{{ $t('doverplanningplanning') }}</span>
    </portal>
    <portal to="app-extension">
      <v-toolbar
        flat
        dense
        :color="$vuetify.theme.dark ? '#121212': ''"
      >
      <span class="title">Production Orders</span>
      <v-spacer></v-spacer>
      <v-btn
        small
        color="primary"
        class="text-none"
        :to="{ name: 'create-new' }"
      >
        Create New
      </v-btn>
      </v-toolbar>
    </portal>
    <v-row class="pt-4 px-4">
      <v-col cols="12" class="text-justify">
        <no-result v-if="false"></no-result>
        <v-form @submit.prevent="search" style="position: relative; padding-top: 8px;" class="">
          <div class="d-flex">
            <v-text-field
              label="PO Number"
              placeholder="Enter PO Number"
              outlined
              v-model="searchquery"
              hide-details
            ></v-text-field>
            <v-btn
              color="primary"
              x-large
              depressed
              type="submit"
              style="height: 56px; position: absolute; right: 0px; top: 8px;"
            >
              Search
            </v-btn>
          </div>
        </v-form>
      </v-col>
      <v-col cols="12" class="text-justify">
        <InfoCard :loading="loading" :salesData="salesData"/>
        <v-card>
          <v-card-text>Form Here</v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import InfoCard from '../components/InfoCard.vue';
import NoResult from '../components/base/NoResult.vue';
// import { sales } from '../components/salesform.json';

export default {
  name: 'Home',
  components: {
    NoResult,
    InfoCard,
  },
  data() {
    return {
      salesData: null,
      loading: false,
      searchquery: '',
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    ...mapActions('planning', ['getRecords']),
    async search() {
      this.loading = true;
      const query = `?query=ponumber=="${this.searchquery}"`;
      const salesData = await this.getRecords({ element: 'sales', queryparam: query });
      if (salesData.length) {
        [this.salesData] = salesData;
      } else {
        this.salesData = null;
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.border-round {
  border-radius: 10px;
}
#home-container {
  height: calc(100vh - 220px);
  overflow: auto;
}
</style>
